/**
 * import { useState } from 'react';
 * import { FaSignOutAlt } from 'react-icons/fa';
 * import { Link } from 'react-router-dom';
 *
 * function UserAvatar({ customerInfo, handleSwitchToSeller, handleLogout }) {
 *   const [showTooltip, setShowTooltip] = useState(false);
 *
 *   const getInitials = (name) => {
 *     if (!name) return '';
 *     const words = name.trim().split(/\s+/);
 *     return words.slice(0, 2).map(w => w[0].toUpperCase()).join('');
 *   };
 *
 *   return (
 *     <div
 *       className="relative inline-block"
 *       onMouseEnter={() => setShowTooltip(true)}
 *       onMouseLeave={() => setShowTooltip(false)}
 *     >
 *       <button
 *         aria-label="User Avatar"
 *         className="flex items-center gap-2 px-2 py-2 text-sm text-white bg-blue-500 rounded-full shadow cursor-pointer hover:bg-orange-500"
 *       >
 *         <span className="flex items-center justify-center w-8 h-8 font-bold text-blue-500 bg-white rounded-full">
 *           {getInitials(customerInfo?.name)}
 *         </span>
 *       </button>
 *
 *       {showTooltip && (
 *   <div
 *     className="absolute z-10 w-60 max-w-xs px-3 py-2 mt-1 text-sm text-gray-800 bg-slate-300 rounded shadow top-full -right-8 mr-[1px]"
 *     onMouseEnter={() => setShowTooltip(true)}
 *     onMouseLeave={() => setShowTooltip(false)}
 *   >
 *     <Link
 *       to="/dashboard"
 *       className="flex items-center justify-start w-full gap-2 px-3 py-2 transition shadow bg-blue-300 rounded-br-full hover:bg-blue-600"
 *     >
 *       <div className="text-sm tex font-montserrat text-gray-600 hover:text-white">Your Customer Board</div>
 *     </Link>
 *     <button
 *       onClick={handleSwitchToSeller}
 *       className="w-full px-3 py-2 my-3 text-left text-blue-600 transition bg-orange-100 rounded-e-sm hover:bg-orange-200"
 *     >
 *       Your Seller Board
 *     </button>
 *     <button
 *       onClick={handleLogout}
 *       className="flex items-center justify-start w-full gap-2 px-3 mb-3 py-2 text-white transition bg-red-500 rounded-br-full hover:bg-red-600"
 *     >
 *       <FaSignOutAlt /> Logout
 *     </button>
 *     <Link
 *       to="/dashboard"
 *       className="block px-3 py-2 mb-2 transition rounded hover:bg-gray-100"
 *     >
 *       <div className="font-semibold uppercase">{customerInfo?.name}</div>
 *       <div className="text-xs text-gray-600">{customerInfo?.email}</div>
 *     </Link>
 *   </div>
 * )}
 *
 *     </div>
 *   );
 * }
 *
 * export default UserAvatar;
 *
 * @format
 */

import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { FaShoppingBag, FaSignOutAlt, FaUser } from "react-icons/fa";
import { RxDashboard } from "react-icons/rx";
import { Link } from "react-router-dom";

function UserAvatar({ customerInfo, handleSwitchToSeller, handleLogout }) {
  const [showTooltip, setShowTooltip] = useState(false);
  const tooltipRef = useRef(null);
  const { t } = useTranslation();
  // Ferme le menu si on clique hors du composant
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (tooltipRef.current && !tooltipRef.current.contains(event.target)) {
        setShowTooltip(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const getInitials = (name) => {
    if (!name) return "";
    const words = name.trim().split(/\s+/);
    return words
      .slice(0, 2)
      .map((w) => w[0].toUpperCase())
      .join("");
  };

  return (
    <div ref={tooltipRef} className='relative inline-block'>
      <button
        aria-label='User Avatar'
        onClick={() => setShowTooltip((prev) => !prev)}
        className='flex items-center gap-2 px-2 py-2 text-sm text-white bg-blue-500 rounded-full shadow cursor-pointer hover:bg-orange-500'
      >
        <span className='flex items-center justify-center w-8 h-8 font-bold text-blue-500 bg-white rounded-full'>
          {getInitials(customerInfo?.name)}
        </span>
      </button>

      {showTooltip && (
        <div className='absolute z-20 w-auto max-w-xs px-3 py-2 mt-1 text-sm text-gray-50 bg-slate-500 rounded shadow top-full -right-8 md-lg:-right-28 mr-[1px]'>
          <div className='py-2 w-full hover:bg-slate-200 flex items-center hover:text-blue-500 cursor-pointer rounded-md'>
            <Link className='flex flex-nowrap gap-1' to='/dashboard'>
              <span className='text-xl font-medium mx-2'>
                <RxDashboard />
              </span>
              <span className='text-sm font-montserrat'>
                {t("Customer Board")}
              </span>
            </Link>
          </div>

          <div
            onClick={handleSwitchToSeller}
            className='py-2 w-full hover:bg-slate-200 flex items-center hover:text-blue-500 cursor-pointer rounded-md flex-nowrap gap-1'
          >
            <span className='text-xl font-medium mx-2'>
              <FaShoppingBag />
            </span>
            <span className='text-sm font-montserrat'>
              {t("Your Seller Board")}
            </span>
          </div>
          <div
            onClick={handleLogout}
            className='py-2 w-full hover:bg-slate-200 flex items-center hover:text-blue-500 cursor-pointer flex-nowrap gap-1 rounded-md '
          >
            <span className='text-xl font-medium mx-2'>
              {" "}
              <FaSignOutAlt />{" "}
            </span>
            <span className='text-sm font-montserrat'>{t("Logout")}</span>
          </div>
          <div className='py-2 w-full hover:bg-slate-200 flex items-center hover:text-blue-500 cursor-pointer rounded-md '>
            <Link
              to='/dashboard'
              className='flex flex-nowrap gap-1 items-center'
            >
              <span className='text-xl font-medium mx-2'>
                <FaUser />
              </span>
              <span className='block px-3 mb-2 transition rounded'>
                <div className='font-semibold uppercase font-montserrat'>
                  {customerInfo?.name}
                </div>
                <div className='text-sm font-montserrat'>
                  {customerInfo?.email}
                </div>
              </span>
            </Link>
          </div>
        </div>
      )}
    </div>
  );
}

export default UserAvatar;
